<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col cols="12" class="text-left mb-2">
                <b-badge :variant="statusVariant(this.status)">
                  <span v-if="this.status === 1">Waiting Approval</span>
                  <span v-else-if="this.status === 2">Approved</span>
                  <span v-else-if="this.status === 3">Rejected</span>
                </b-badge>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Employee Name" label-for="name">
                  <b-form-input
                    id="name"
                    placeholder="Employee Name"
                    v-model="form.name"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Amount" label-for="amount">
                  <cleave
                    id="amount"
                    placeholder="Amount"
                    v-model="form.amount"
                    class="form-control"
                    :raw="false"
                    :options="options.number"
                    :disabled="this.status !== 1 ? true : false"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    :disabled="this.status !== 1 ? true : false"
                    required
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="secondary"
                  block
                  v-b-modal.modal-lg
                  class="my-1"
                >
                  View Photo
                </b-button>

                <b-modal
                  id="modal-lg"
                  ok-only
                  ok-title="close"
                  centered
                  size="lg"
                  title="Reimbursement Photo"
                  class="text-center"
                >
                  <b-img
                    id="photo"
                    :src="photo"
                    width="1000px"
                    fluid
                    alt="reimbursement photo"
                  />
                </b-modal>
              </b-col>
              <b-col cols="12" v-if="this.status === 3">
                <b-form-group label="Reject Reason" label-for="reject_reason">
                  <b-form-textarea
                    id="reject_reason"
                    placeholder="Reject Reason"
                    v-model="form.reject_reason"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                class="mt-1"
                v-if="
                  permissions.includes('reimbursement-update') && status === 1
                "
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="updateReimbursement()"
                  block
                >
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col
        cols="6"
        class="mt-0"
        v-if="permissions.includes('reimbursement-approval') && status === 1"
      >
        <b-row>
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              block
              v-b-modal.modal-reject
            >
              Reject
            </b-button>
          </b-col>
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1"
              block
              @click="approve()"
            >
              Approve
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <!-- modal change password -->
      <b-modal
        id="modal-reject"
        title="Reject Form"
        ok-title="Reject"
        cancel-variant="outline-secondary"
        hide-footer
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Reject Reason"
              label-for="reject"
              invalid-feedback="Reject Reason required"
            >
              <validation-provider
                #default="{ errors }"
                name="reject"
                rules="required"
              >
                <b-form-input
                  id="reject"
                  name="reject"
                  type="text"
                  v-model="form.reject_reason"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Reject Reason"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-3"
                  type="submit"
                  variant="danger"
                  block
                  @click="reject()"
                >
                  Reject
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- end modal change password -->
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BBadge,
  BImg,
  BFormTimepicker,
  BFormDatepicker,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import flatPickr from "vue-flatpickr-component";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";

export default {
  components: {
    ToastificationContent,
    flatPickr,
    Cleave,
    BFormTextarea,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    BImg,
    BFormTimepicker,
    BFormDatepicker,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    draggable,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        name: "",
        amount: null,
        description: "",
        reject_reason: "",
      },
      status: "",
      photo: "",
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      permissions: [],
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-success",
        3: "light-danger",
      };

      return (status) => statusColor[status];
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http
        .get("reimbursements/" + id)
        .then((response) => {
          // console.log(response.data.data)
          this.status = response.data.data.status;
          this.form.name = response.data.data.user_name;
          this.form.amount = response.data.data.amount;
          const { baseUrl } = $themeConfig.app;
          this.photo = baseUrl;
          this.photo += "storage/reimbursement/";
          this.photo += response.data.data.image;
          // console.log(this.photo)
          this.form.description = response.data.data.description;
          this.form.reject_reason = response.data.data.reject_reason;
        })
        .catch((errors) => {
          console.log(errors.response);
        });
    },
    updateReimbursement() {
      const id = this.$route.params.id;
      var newAmount = this.form.amount;
      newAmount = newAmount.replace(/\,/g, "");
      this.$http
        .post("reimbursements/" + id + "/update", {
          amount: newAmount,
          description: this.form.description,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update Reimbursement",
              variant: "success",
            },
          });
          location.href = "/hr/reimbursements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    approve() {
      const id = this.$route.params.id;
      this.$http
        .post("reimbursements/" + id + "/approve")
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Reimbursement Approved",
              variant: "success",
            },
          });
          location.href = "/hr/reimbursements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    reject() {
      const id = this.$route.params.id;
      this.$http
        .post("reimbursements/" + id + "/reject", {
          reject_reason: this.form.reject_reason,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Reimbursement Rejected",
              variant: "danger",
            },
          });
          location.href = "/hr/reimbursements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>